import _axios from '../../apiClient'

export function GetAllMarcas() {
  return _axios
    .get(`/api/Marca/GetAllMarcas`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log('Error en la petición de Marca:', error)
      const data = error.response.data
      throw data
    })
}

export function getMarca(idMarca) {
  return _axios
    .get(`/api/Marca/GetMarca/${idMarca}`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data;
      throw (data);
    })
}

export function getMarcaByCodigo(codigo) {
  return _axios.get(`/api/Marca/GetMarcaByCodigo`, {
      params: { codigo },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
      const data = error.response.data;
      throw (data);
  });
}

export function getMarcaByNombre(nombre) {
  return _axios.get(`/api/Marca/GetMarcaByNombre`, {
      params: { nombre },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
      const data = error.response.data;
      throw (data);
  });
}

export function saveMarca(payload) {
  return _axios.post(`/api/Marca/SaveMarca`, payload, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
      const data = error.response.data;
      throw (data);
  });
}

export function deleteMarca(idMarca) {
  return _axios.delete(`/api/Marca/DeleteMarca/${idMarca}`, {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  })
  .then(response => response.data)
  .catch((error) => {
      const data = error.response.data;
      throw new Error(data.message || "Ocurrió un error al eliminar la marca.");
  });
}